/**
 * A Vue.js directive that ensures the input value contains only numeric characters and periods.
 *
 * @module model-numeric
 *
 * @example
 * <input v-model-numeric>
 *
 * @description
 * This directive listens for the 'input' event on the element and removes any non-numeric characters
 * and periods from the input value. It then updates the input value and dispatches a new 'input' event.
 *
 * @param {HTMLElement} el - The element to which the directive is bound.
 */
export default {
  update (el, binding, vnode) {
    const vueComponent = vnode.componentInstance

    if (!vueComponent) {
      return
    }

    const currentValue = vueComponent.internalValue || ''
    const cleanValue = currentValue.replace(/[^0-9.]/g, '').replace(/\.(?=.*\.)/g, '')

    // no need to update the value if it hasn't changed
    if (currentValue === cleanValue) {
      return
    }

    // dispatch a new input event with the cleaned
    // value & update the internal value
    vueComponent.$emit('input', cleanValue)

    vueComponent.$nextTick(() => {
      vueComponent.internalValue = cleanValue
    })
  }
}
